import { formURL } from "Utils/CommonUtilities";
import BaseApiRequest from "./BaseApiRequest";
import { GET_PRODUCT_INFORMATION_URL } from "../ApiUrls";
import { METHOD } from "../Constants";

import { getCurrentUserParameters } from "../../Utils/CommonUtilities";

export default class GetProductInformationRequest extends BaseApiRequest {
  method = METHOD.HTTP.GET;

  body = {};

  url = GET_PRODUCT_INFORMATION_URL;

  constructor(paramList) {
    super();
    this.url = formURL(this.url, paramList);
  }

  getMethod = () => this.method;

  getUrl = () => getCurrentUserParameters(this.url);

  getBody = () => this.body;
}
